import UIResource from '@/components/UIResource';
import { FiltersPriceType } from '@/infra/types/common/filters';

type Props = {
  itineraryDetails?: boolean;
  priceType: 'perCabin' | 'perSailor' | 'perSuite';
  suite: boolean;
};

export const PriceFootnote = ({ itineraryDetails, priceType, suite }: Props) => {
  let priceTypeLabel = priceType;

  if (priceType === FiltersPriceType.perCabin && suite) {
    priceTypeLabel = 'perSuite';
  }

  if (itineraryDetails) {
    return (
      <p className="PriceFootnote">
        <UIResource id={`PriceFootnote.flyout.${priceTypeLabel}`} />
      </p>
    );
  }

  return <UIResource id={`PriceFootnote.${priceTypeLabel}`} />;
};
